(function () {
  var CYCLE = ['THB', 'USD', 'EUR'];
  var SYMBOLS = { THB: '฿', USD: '$', EUR: '€' };
  var rates = { THB: 1, USD: 0.0292, EUR: 0.0270 };
  var current = localStorage.getItem('tik_cur') || 'THB';

  fetch('https://open.er-api.com/v6/latest/THB')
    .then(function(r){ return r.json(); })
    .then(function(d){ rates.USD = d.rates.USD; rates.EUR = d.rates.EUR; convertAll(); })
    .catch(function(){});

  function parseTHB(text) {
    var n = parseFloat(text.replace(/[^0-9.]/g, ''));
    return isNaN(n) || n < 1 ? null : n;
  }

  function fmt(thb, cur) {
    var val = Math.round(thb * rates[cur]);
    return SYMBOLS[cur] + val.toLocaleString('en-US');
  }

  var SEL = '.tour-card__price-value, .carousel-item__price, .tour-price, #total-price, #btn-price';

  function seedPrices() {
    document.querySelectorAll(SEL).forEach(function(el) {
      if (el.hasAttribute('data-thb')) return;
      var thb = parseTHB(el.textContent);
      if (thb) el.setAttribute('data-thb', thb);
    });
  }

  function convertAll() {
    document.querySelectorAll('[data-thb]').forEach(function(el) {
      var thb = parseFloat(el.getAttribute('data-thb'));
      if (!isNaN(thb)) el.textContent = fmt(thb, current);
    });
    var btn = document.getElementById('tik-cur-btn');
    if (btn) btn.textContent = current;
    document.querySelectorAll('.tik-currency-btn').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-currency') === current);
    });
  }

  function cycle() {
    var idx = CYCLE.indexOf(current);
    current = CYCLE[(idx + 1) % CYCLE.length];
    localStorage.setItem('tik_cur', current);
    convertAll();
  }

  function injectButton() {
    if (document.getElementById('tik-cur-btn')) return;
    var btn = document.createElement('button');
    btn.id = 'tik-cur-btn';
    btn.textContent = current;
    btn.setAttribute('aria-label', 'Change currency');
    btn.addEventListener('click', cycle);
    var actions = document.querySelector('.header-actions');
    if (actions) actions.insertBefore(btn, actions.firstChild);
  }

  // EU members + EFTA + UK. UK gets EUR because we don't carry GBP.
  var EU = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','GB','CH','NO','IS','LI'];
  // Anglophone + APAC markets that mentally price in USD.
  var USD_MARKETS = ['US','CA','MX','AU','NZ','SG','HK','JP','PH','MY','ID','IN','BR','AR','CL','CO','KR','TW','SA','AE','IL','ZA','TR','RU'];

  function autoDetect() {
    if (localStorage.getItem('tik_cur')) return;
    if (localStorage.getItem('tik_geo_tried')) return;
    localStorage.setItem('tik_geo_tried', '1');
    fetch('https://ipapi.co/country/')
      .then(function(r){ return r.text(); })
      .then(function(country){
        var c = (country || '').trim().toUpperCase();
        if (!/^[A-Z]{2}$/.test(c)) return;
        var target = null;
        if (c === 'TH') target = 'THB';
        else if (EU.indexOf(c) >= 0) target = 'EUR';
        else if (USD_MARKETS.indexOf(c) >= 0) target = 'USD';
        if (!target || target === current) return;
        current = target;
        localStorage.setItem('tik_cur', target);
        convertAll();
      })
      .catch(function(){});
  }

  function init() {
    injectButton();
    seedPrices();
    if (current !== 'THB') convertAll();
    autoDetect();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  window.tikSetCurrency = function(c) {
    current = c; localStorage.setItem('tik_cur', c); convertAll();
  };
})();
